import { useField } from 'react-final-form'
import useTranslate from '../../i18n/useTranslate'
import { composeValidators, selectRequired } from '../../utilities/validate'
import { useType } from './autocompleteType'

export type FieldRequired = boolean | { showAsterisk?: boolean; triggedValidate?: boolean; errorMessage?: string }

const useMyAutocomplete = (props: useType) => {
    const { name, required, validates = [] } = props
    const translate = useTranslate()
    let mergeValidate = validates
    if ((typeof required === 'boolean' && required) || (typeof required === 'object' && required?.triggedValidate)) {
        mergeValidate = [
            selectRequired(typeof required === 'object' ? required.errorMessage : `${translate.get('MESSAGE.M016')}`),
            ...mergeValidate,
        ]
    }

    const field = useField<any>(name, {
        validate: composeValidators(...mergeValidate),
    })

    return { field }
}

export default useMyAutocomplete
